/**
 * Trunca um texto para um tamanho máximo e adiciona "..." no final, se necessário.
 * 
 * @param {string} text - Texto original
 * @param {number} maxLen - Tamanho máximo antes de truncar (default: 27)
 * @returns {string} Texto truncado (ou o original se menor que o limite)
 */
export function truncate(text, maxLen = 27) {
    if (!text) return '';
    return text.length > maxLen ? text.slice(0, maxLen) + '...' : text;
}